import React, { FC } from "react";
import { SimpleDialogFallback } from "../DialogComponents/DialogFallback/SimpleDialogFallback";
import { DIALOG_STYLE } from "./context";

export const SelectResources: FC = () => {
  return <SimpleDialogFallback context={DIALOG_STYLE} />;
};
